import { CheckCircleOutline, Close } from '@mui/icons-material';
import { Skeleton, Stack } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CellProps } from 'react-table';

import { IRow } from '@work4all/components';

import { FileServiceProviderConfig } from '@work4all/models/lib/Classes/FileServiceProviderConfig.entity';
import { FileServiceProviderType } from '@work4all/models/lib/Enums/FileServiceProviderType.enum';

import { useFspStatusContext } from './file-service-provider-config-table/FspStatusContext';

type Props = CellProps<IRow, FileServiceProviderConfig>;

export const FspStatusCell = ({ value, row }: Props) => {
  const ctx = useFspStatusContext();

  const { t } = useTranslation();

  const element = useMemo(() => {
    return ctx.result.data?.fspDiagnostic.fspProviderTestResults?.find(
      (y) => y.fspId === value
    );
  }, [ctx.result.data, value]);

  const confItem = row?.original as FileServiceProviderConfig;

  useEffect(() => {
    if (
      !element &&
      confItem?.providerType !== FileServiceProviderType.LOCAL_FILE_SYSTEM
    ) {
      ctx.result.refetch();
    }
  }, [confItem?.providerType, ctx.result, element]);

  return ctx.result.loading ? (
    <Skeleton />
  ) : (
    <Stack direction="row" alignItems="center" gap="0.25rem">
      {element?.isSuccess ? (
        <CheckCircleOutline color="success" />
      ) : (
        <Close color="error" />
      )}
      {element?.isSuccess ? t('COMMON.OK') : element?.errorMessage}
    </Stack>
  );
};
